export const CONTACTS = {
  telefono: "352 0790805",
  telefonoHref: "tel:+393520790805",
  whatsappDisplay: "352 0790805",
  whatsappNumber: "393520790805",
  email: "info@synapsesneurologia.com",
  indirizzo: "Via Avigliana, 38, 10138 Torino (TO)",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Via+Avigliana+38%2C+10138+Torino",
  orari: "Lun, Mar, Ven 14:00–18:30 · Mer, Gio 9:00–13:00",
  miodottore: "https://www.miodottore.it/",
};

export const WA_URL = `https://wa.me/${CONTACTS.whatsappNumber}?text=${encodeURIComponent(
  "Buongiorno, ho un sintomo e vorrei capire quale esame fa per me."
)}`;

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/prestazioni", label: "Prestazioni" },
  { to: "/il-centro", label: "Il Centro" },
  { to: "/team", label: "Team" },
  { to: "/recensioni", label: "Recensioni" },
  { to: "/faq", label: "FAQ" },
  { to: "/prenota", label: "Prenota" },
];

export const EXAMS = [
  {
    num: "01",
    name: "Elettromiografia (EMG)",
    short: "La funzione di nervi periferici e muscoli.",
    description:
      "Esame della funzione dei nervi periferici e dei muscoli. Permette di osservare direttamente come lavorano i nervi e dove può trovarsi il problema.",
    quando:
      "Viene generalmente richiesto in caso di cervicalgia, lombalgia, formicolii e bruciori a mani o piedi, intorpidimento notturno, dolori a mani e braccia o a piedi e gambe, debolezza muscolare acuta a un arto, oppure dopo un episodio traumatico seguito da deficit di forza o di sensibilità.",
    segnale:
      "I disturbi da tunnel carpale — intorpidimento, formicolii e bruciori alla mano, prevalentemente notturni — vengono in un discreto numero di casi trascurati, nella convinzione che passeranno. In alcuni casi questo può pregiudicare l'efficacia di un intervento semplice e risolutivo.",
    referto: "Immediato",
    refertoNote: "consegnato durante l'esame",
  },
  {
    num: "02",
    name: "Elettroencefalogramma (EEG)",
    short: "La registrazione dell'attività elettrica cerebrale.",
    description:
      "Registrazione dell'attività elettrica cerebrale, utile quando si sospetta che alcuni episodi possano avere un'origine nella funzione elettrica del cervello.",
    quando:
      "Viene generalmente richiesto in caso di sospetta crisi epilettica — scosse agli arti, convulsioni, improvvisa perdita di coscienza, distacco dall'ambiente senza perdita di coscienza — oppure in caso di episodi di confusione e disorientamento nell'anziano.",
    segnale:
      "Nei bambini e negli adolescenti, gli episodi di «assenza» o di «incantamento» vengono spesso ignorati da genitori e insegnanti, e interpretati come tratti caratteriali o distrazione.",
    referto: "24–48 ore",
    refertoNote: "consegnato entro due giorni lavorativi",
  },
  {
    num: "03",
    name: "Poligrafia del sonno",
    short: "La registrazione notturna cardiorespiratoria.",
    description:
      "Registrazione notturna dei parametri cardiorespiratori durante il sonno. Può essere eseguita al domicilio, con la strumentazione consegnata e spiegata dal centro.",
    quando:
      "Viene generalmente richiesta in caso di sovrappeso o obesità, russamento cronico, riposo notturno di scarsa qualità, sonnolenza e stanchezza diurne, deficit di memoria e alterazioni del comportamento in soggetti giovani o adulti.",
    segnale:
      "Obesità e russamento vengono spesso considerati normali e come tali non meritevoli di accertamento. Nella maggior parte dei casi non è così.",
    referto: "7 giorni",
    refertoNote: "con indicazioni cliniche incluse",
  },
  {
    num: "04",
    name: "Polisonnografia",
    short: "Lo studio completo del sonno.",
    description:
      "Studio completo del sonno: attività cerebrale, respirazione, movimenti e parametri cardiaci registrati insieme, per ricostruire che cosa accade durante la notte.",
    quando:
      "Viene generalmente richiesta in caso di insonnia cronica, manifestazioni motorie o atipiche durante il sonno — agitazione, urla, sonnambulismo — oppure episodi di caduta improvvisa in veglia quando gli altri accertamenti sono risultati negativi, in questo caso associata al test delle latenze multiple.",
    segnale:
      "I disturbi del sonno vengono in genere considerati una caratteristica della persona, e ci si informa su uno studio del sonno soltanto quando le ricadute sulla qualità della vita diventano importanti.",
    referto: "14 giorni",
    refertoNote: "con indicazioni cliniche incluse",
  },
];

export const ALTRE_PRESTAZIONI = [
  {
    name: "Visita neurologica specialistica",
    description:
      "La prima visita è pensata per il tempo necessario a ricostruire la storia clinica completa, i sintomi nel dettaglio e l'impatto sulla vita quotidiana. Non per rientrare in uno slot fisso.",
  },
  {
    name: "Test delle latenze multiple",
    description:
      "Misura la propensione ad addormentarsi durante il giorno, spesso associato alla polisonnografia quando gli altri accertamenti sono risultati negativi.",
  },
  {
    name: "Ecografia del nervo",
    description:
      "Una prestazione di frontiera che sta iniziando a diffondersi e che pochi ambulatori privati offrono: permette di osservare direttamente la struttura dei nervi periferici.",
  },
];

export const EXAM_OPTIONS = [
  "Visita neurologica specialistica",
  "Elettromiografia (EMG)",
  "Elettroencefalogramma (EEG)",
  "Poligrafia del sonno",
  "Polisonnografia",
  "Test delle latenze multiple",
  "Ecografia del nervo",
  "Non lo so ancora — vorrei un consiglio",
];

export const TEAM = [
  {
    name: "Dott. Enrico Cavallo",
    role: "Neurologo · Fondatore e Direttore sanitario",
    areas: "Cefalee, epilessia, malattie neuromuscolari e neuropatie",
    bio: "Laureato con lode in Medicina e Chirurgia all'Università di Torino (2006), specializzato con lode in Neurologia (2012). Membro della Società Italiana di Neurofisiologia Clinica (SINC), autore di pubblicazioni scientifiche, ha maturato la sua esperienza in contesti ospedalieri, accademici e ambulatoriali.",
    featured: true,
  },
  {
    name: "Dott. Luca Benedetto Sicuro",
    role: "Neurologo",
    areas: "Neuropatie, nevralgie, terapia del dolore, agopuntura",
    bio: "Ha lavorato per la maggior parte della carriera presso la Neurologia e poi la Terapia Antalgica dell'Ospedale Molinette di Torino.",
  },
  {
    name: "Dott.ssa Elena Peila",
    role: "Neurologa",
    areas: "Disturbi dell'umore, disturbi del sonno, epilessia, stimolazione transcranica",
    bio: "Ha conseguito il dottorato post-specializzazione presso il Centro di Medicina del Sonno dell'Ospedale Molinette di Torino.",
  },
  {
    name: "Dott.ssa Antonella Tribolo",
    role: "Neurologa",
    areas: "Disturbi del sonno",
    bio: "Ha lavorato per la maggior parte della carriera presso la Neurologia dell'Ospedale Molinette di Torino.",
  },
  {
    name: "Dott. Giorgio Capoccitti",
    role: "Neurofisiologo",
    areas: "Epilessia, malattie neuromuscolari e neuropatie",
    bio: "Si occupa della diagnostica neurofisiologica del centro.",
  },
  {
    name: "Alice Robert",
    role: "Tecnico di Neurofisiopatologia",
    areas: "Neurofisiologia, medicina del sonno, epilessia",
    bio: "Ha lavorato per molti anni presso i servizi di Neurofisiologia dell'Ospedale Molinette di Torino, in particolare presso il Centro di Medicina del Sonno e il Centro Epilessia.",
  },
  {
    name: "Simone Vaccarella",
    role: "Tecnico di Neurofisiopatologia",
    areas: "Elettromiografia, elettroencefalografia, esami del sonno",
    bio: "Esegue e assiste gli esami strumentali del centro.",
  },
];

export const FAQS = [
  {
    q: "Quanto dura la prima visita?",
    a: "È pensata per il tempo necessario a ricostruire la storia clinica completa e i sintomi nel dettaglio, non per rientrare in uno slot fisso. Il tempo che serve è parte della visita.",
  },
  {
    q: "In quanto tempo ricevo il referto?",
    a: "Elettromiografia: subito, durante l'esame. Elettroencefalogramma: 24–48 ore. Poligrafia: 7 giorni. Polisonnografia: 14 giorni. Poligrafia e polisonnografia includono indicazioni cliniche.",
  },
  {
    q: "Serve l'impegnativa del medico di base?",
    a: "No: si tratta di prestazioni private, per cui non è richiesta l'impegnativa.",
  },
  {
    q: "L'elettromiografia fa male?",
    a: "È una preoccupazione frequente e legittima. L'esame comprende una parte con ago e può comportare un fastidio: ne parliamo insieme prima di iniziare, con calma.",
  },
  {
    q: "Come si prenota?",
    a: "Per telefono, su WhatsApp, tramite il modulo di questo sito oppure dal portale MioDottore. La richiesta dal sito non è una prenotazione automatica: ti proponiamo un orario entro 24 ore, senza impegno.",
  },
  {
    q: "Dove siete?",
    a: "In Via Avigliana 38, a Torino.",
  },
];

export const PAZIENTI = [
  {
    title: "Adulti e giovani adulti sotto stress",
    text: "Prevalentemente donne, con mal di testa ricorrente o cronico, flessione dell'umore, ansia e disturbi del sonno.",
  },
  {
    title: "Persone anziane",
    text: "Con deterioramento cognitivo o disturbi motori — difficoltà di deambulazione, instabilità, tremore. Spesso la richiesta di aiuto arriva dai familiari.",
  },
  {
    title: "Giovani con fascicolazioni muscolari",
    text: "Persone ansiose che davanti alla comparsa di «guizzi» muscolari persistenti si spaventano e cercano un accertamento.",
  },
  {
    title: "Adulti con deficit di memoria",
    text: "Anche giovani adulti che si allarmano per piccole difficoltà mnesiche o nel trovare le parole, spesso su base ansiosa o da stress.",
  },
  {
    title: "Persone con cefalea",
    text: "Chi ha un mal di testa «serio» per la prima volta e si spaventa, e chi convive con la cefalea da anni senza essere mai stato gestito correttamente.",
  },
];

export const VALORI = [
  {
    num: "01",
    title: "Ascolto ed empatia",
    text: "Il paziente neurologico è spesso complesso. In molte situazioni può accadere che il medico non voglia farsi carico del caso, per le difficoltà tecniche che comporta. Synapses vuole dare ascolto e spazio a queste persone.",
  },
  {
    num: "02",
    title: "Collaborazione",
    text: "Mettiamo il bene del paziente al primo posto e lavoriamo sul confronto con altri specialisti più competenti in campi specifici, condividendo le informazioni.",
  },
  {
    num: "03",
    title: "Competenza e formazione continua",
    text: "La conoscenza medica progredisce a ritmi che non permettono a nessuno di restare aggiornato da solo. Investiamo in formazione in Italia e all'estero.",
  },
  {
    num: "04",
    title: "Tempi rapidi",
    text: "Sui referti e sulla disponibilità a rispondere. Dal referto immediato dell'EMG alle risposte entro 24 ore sulle richieste di appuntamento.",
  },
];

export const PILASTRI = [
  {
    num: "01",
    title: "Ascolto",
    text: "Presa in carico anche quando il problema di salute non si può risolvere. Il primo atto clinico è ascoltare.",
  },
  {
    num: "02",
    title: "Competenza",
    text: "Specializzazione vera e collaborazione tra professionisti, per trovare le soluzioni migliori possibili.",
  },
  {
    num: "03",
    title: "Disponibilità",
    text: "Una presenza continuativa nel tempo, per rispondere ai dubbi e ai problemi clinici quando emergono.",
  },
];

export const PAROLE_CHIAVE = ["Accogliente", "Efficiente", "Rassicurante", "Umano"];

export const SIGNATURE =
  "Synapses · Centro specialistico in Neurologia e Medicina del Sonno · Torino";
